import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontSizes, lineHeights, palette,
}: Theme) => ({
  root: {
    padding: '1.5rem',
    [breakpoints.up('md')]: {
      padding: '3rem',
    },
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
  withBorder: {
    borderTop: `1px solid ${palette.grey[400]}`,
    marginTop: '1.5rem',
    paddingTop: '1.5rem',
  },
  title: {
    margin: '0 0 2rem',
    fontSize: '1.25rem',
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
    },
  },
  description: {
    margin: '0',
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  helperText: {
    margin: 0,
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    color: palette.text.secondary,
  },
  subtitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  subtitle: {
    margin: 0,
    fontSize: '1rem',
    lineHeight: 1.5,
    [breakpoints.up('md')]: {
      fontSize: '1.25rem',
      lineHeight: 1.4,
    },
  },
  storeContent: {
    flexDirection: 'column',
  },
}));
